import script from "./Modal3DRender.vue?vue&type=script&setup=true&lang=js"
export * from "./Modal3DRender.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__